import { getSipSvrDate, queueActionSip, makeCallSip } from '@/sip/sip_api'
import { Notification } from 'element-ui'
import { pushAgentpull } from '@/sip/sip_push_api'
import md5 from 'js-md5'
// import { getToken } from '../utils/auth'
import store from '../../src/store/store'
// import { PostAPI } from '@/api/usermanage'
// import { misPhoneAlarm } from '../api/phone'

let isNginxPush = false
let isNginxPushLoop = false
let isCanSip = true
let ccdate = null
let cctag = null
let sipUserList = null
let isQuery = true
let calleridnum = null

export const startSIP = () => {
  sipUserList = store.state.user.sipinfo
  if (store.state.user.role.indexOf('csd') > -1) {
    openSip()
  }
  // if (isCanSip) {
  //   if (store.state.user.role.indexOf('csd') > -1) {
  //     openSip()
  //   }
  // }
}

function openSip () {
  if (isCanSip) {
    // isCanSip = false
    const timestamp = new Date().getTime()
    // console.log('15', sipUserList)
    if (sipUserList.sip_svrip) {
      // var sipUser = sipUserList[0]
      let baseurl = 'http://' + sipUserList.sip_svrip
      let arr = ['http://', 'https://']
      for (let i = 0; i < arr.length; i++) {
        if (sipUserList.sip_svrip.includes(arr[i])) {
          baseurl = sipUserList.sip_svrip
        }
      }

      getSipSvrDate(baseurl, timestamp).then(response => {
        var response2 = response.substring(3, response.length - 1)
        var response2json = JSON.parse(response2)
        ccdate = response2json.ccdate
        isNginxPush = true
        checkInSIP(1)
      })
    }
  }
}

export const checkInSIP = (isCheck) => {
  if (sipUserList.sip_svrip) {
    var sipUser = sipUserList
    const timestamp = new Date().getTime()
    let baseurl = 'http://' + sipUser.sip_svrip
    let arr = ['http://', 'https://']
    for (let i = 0; i < arr.length; i++) {
      if (sipUserList.sip_svrip.includes(arr[i])) {
        baseurl = sipUserList.sip_svrip
      }
    }
    queueActionSip(baseurl, isCheck, sipUser.username, sipUser.sip_orgid, sipUser.sip_id_list, sipUser.password, timestamp).then(response => {
      var response2 = response.substring(3, response.length - 1)
      var response2json = JSON.parse(response2)
      console.log(response2json)
      console.log('坐席签入签出成功')
    })
  }
}

export const makePhoneCall = (phonenum) => {
  // targetdn, agentgroupid, user, orgidentity, password, model_id
  // '18112545657', '2', '8002', '8', 'z2020', '1',
  if (sipUserList.sip_svrip) {
    var sipUser = sipUserList
    const timestamp = new Date().getTime()
    let baseurl = 'http://' + sipUser.sip_svrip
    let arr = ['http://', 'https://']
    for (let i = 0; i < arr.length; i++) {
      if (sipUserList.sip_svrip.includes(arr[i])) {
        baseurl = sipUserList.sip_svrip
      }
    }
    makeCallSip(baseurl, phonenum, sipUser.sip_id_list, sipUser.username, sipUser.sip_orgid, sipUser.password, '1', timestamp).then(response => {
      var response2 = response.substring(3, response.length - 1)
      var response2json = JSON.parse(response2)
      console.log(999, response2json)
    })
  }
}

export const reStartSip = () => {
  isCanSip = true
  startSIP()
}

export const stopSip = () => {
  checkInSIP(2)
  isNginxPush = false
}

// eslint-disable-next-line no-unused-vars
function isCanNginxPush () {
  // console.log('ok31', isNginxPush, isNginxPushLoop)
  if (isNginxPush) {
    if (isNginxPushLoop) {
      setTimeout(pushAgent(), 1100)
    }
  }
}

function pushAgent () {
  isNginxPushLoop = false
  var timestamp = new Date().getTime()
  var sipUser = sipUserList
  var md5pwd = md5(sipUser.password)
  var url = sipUser.sip_orgid + '-' + sipUser.username + '-' + md5pwd
  var urldate = ccdate.replace(/ /g, '%20')
  const baseurl = 'http://' + sipUser.sip_svrip
  pushAgentpull(baseurl, url, timestamp, cctag, urldate).then(
    response => {
      isNginxPushLoop = true
      var response1 = response.substring(16, response.length - 4)
      var response2 = response1.replace(/,]/g, ']')
      var response2json = JSON.parse(response2)
      for (let i = 0; i < response2json.length; i++) {
        ccdate = response2json[i].time
        cctag = response2json[i].tag
        var text = response2json[i].text.replace(/'/g, '"')
        var text2 = JSON.parse(text)
        // eslint-disable-next-line no-unused-vars
        var phoneSource
        if (text2.source === 'AGENT') {
          phoneSource = '坐席'
        } else if (text2.source === 'CALLER') {
          phoneSource = '呼入客户'
        } else if (text2.source === 'CALLEE') {
          phoneSource = '被叫客户'
        } else if (text2.source === 'CONVERSATION') {
          phoneSource = '全部通话'
        } else if (text2.source === 'CONSULT') {
          phoneSource = '第 N 方'
        }
        var phoneEvent
        if (text2.event === 'ringing') {
          phoneEvent = '振铃'
        } else if (text2.event === 'answer') {
          phoneEvent = '应答'
        } else if (text2.event === 'hangup') {
          phoneEvent = '挂断'
        } else if (text2.event === 'join') {
          phoneEvent = '加入'
        } else if (text2.event === 'incoming') {
          phoneEvent = '来电'
        } else if (text2.event === 'onhold') {
          phoneEvent = '暂停'
        } else if (text2.event === 'resume') {
          phoneEvent = '恢复'
        }
        if (phoneEvent === '来电') {
          if (calleridnum !== text2.calleridnum) {
            isQuery = true
          }
          calleridnum = text2.calleridnum
          if (isQuery) {
            isQuery = false
            setTimeout(() => {
              isQuery = true
            }, 30000)
          }
        }

        var phoneCallType
        if (text2.calltype === 'dialout') {
          phoneCallType = '电话拨出'
        } else if (text2.calltype === 'dialin') {
          phoneCallType = '电话呼入'
        }

        if (text2.source === 'CONVERSATION') {
          Notification({
            title: '提示',
            message: '当前通话结束',
            type: 'success',
            duration: 1000
          })
        } else {
          Notification({
            title: phoneCallType + '- -' + phoneEvent,
            message: '电话号码：' + text2.calleridnum,
            type: 'success',
            duration: 1500
          })
        }
      }
    },
    error => {
      isNginxPushLoop = true
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/sip/sip_index.js